import {get, post, put, del} from "@/utils/request";


export default {
    //获取所有的分类
    getList: (param) => {
        return get('/category', param);
    },
    //获取所有的分类
    getAllList: () => {
        return get('/category/list');
    },
    //通过分类ID获取分类信息
    getData: (id) => {
        return get('/category/'+id);
    },
    //新增分类信息
    addData: (data) => {
        return post('/category', data);
    },
    //修改分类信息
    updateData: (data) => {
        return put('/category', data);
    },
    //删除分类信息
    deleteData: (id) =>{
        return del('/category/'+id);
    },
    //根据员工号获取该员工的分类范围
    getDataByWorkNo: (data) =>{
        return get('/category/getDataByWorkNo/'+data);
    },
    //根据管理员员工号获取该管理员管理的分类范围
    getDataByAdminWorkNo: (data) =>{
        return get('/category/adminList/'+data);
    },
}